import moment from "moment";

const SUBSCRIPTION_BASIC_DAYS = 8;

export function getFirstPaidDay() {
	return moment().startOf("day").add(SUBSCRIPTION_BASIC_DAYS, "days");
}
